<div
  class="appbar bg-white d-flex justify-content-between align-items-center px-4"
>
  <app-search-bar-input-field></app-search-bar-input-field>
  <!-- <app-custom-button text="Refresh" [width]="'130px'"></app-custom-button> -->
  <app-appbar-profile-options></app-appbar-profile-options>
</div>
